import GameSliderContainer from 'components/GameSliderContainer'
import React from 'react'
import useRecentGames from './hooks/useRecentGames'
import GetSliderGames from './GetSliderGames'
import useFavoriteGames from '../../hooks/useFavoriteGames'
import { useSelector } from 'react-redux'
import NoDataAvailable from 'components/NoDataAvailable'

const RecentGames = () => {
  const {
    recentGames,
    userDetails,
    navigate,
    selectedLanguageCode,
    languageData
  } = useRecentGames({ category: true })

  const uiConfig = useSelector((state) => state?.uiConfig?.general)
  const { recentGamesSliderVariant } = uiConfig || {}

  const { favoriteGamesList, toggleFavorite } = useFavoriteGames()

  return (
    userDetails?.userId && (
      !!recentGames?.length ? (
        <GameSliderContainer>
          <GetSliderGames
            variant={recentGamesSliderVariant}
            games={recentGames}
            name={languageData?.recentGames || 'Recent Games'}
            recent
            selectedLanguageCode={selectedLanguageCode}
            navigate={navigate}
            languageData={languageData}
            toggleFavorite={toggleFavorite}
            favoriteGamesList={favoriteGamesList}
          />
        </GameSliderContainer>
      ) : (
        <div className='recent-games no-data-found' dir='ltr'>
          <NoDataAvailable errorMessage={languageData?.casinoNoGamesFound} />
        </div>
      ))
  )
}

export default RecentGames
